<template>
  <div style="width: 100%" class="fullSize">
    <div v-if="isNotDesktop" class="navDraw-helper"></div>
    <v-tabs-items class="accent fullSize">
      <div :class="{ fullSize: loadingCharts || loadingDefinitions }">
        <loading-page
            v-if="loadingCharts || loadingDefinitions"
            class="fullSize"
        ></loading-page>
        <default-page
            v-else-if="!layout.length"
            imageUrl="/img/dynamic-src-images/price-watcher.svg"
            title="Price Watcher"
            :text="emptyPageText"
            buttonText="Create"
            @button-clicked="openChartDialog"
        ></default-page>
        <div
            v-else
            class="mx-2"
            style="
            overflow-y: auto;
            overflow-x: hidden;
            height: calc(100vh - 58px);
          "
        >
          <grid-layout
              v-if="layout.length"
              ref="grid-layout"
              :layout.sync="layout"
              :is-draggable="true"
              :is-resizable="resizable"
              :vertical-compact="true"
              :use-css-transforms="true"
              :class="$vuetify.theme.dark ? 'darkTheme' : 'lightTheme'"
              class="PW-card-layout"
              style="margin-bottom: 120px"
              :margin="[20, 20]"
              :col-num="18"
              :row-num="2"
              :row-height="64"
              :min-h="6"
              :min-w="6"
              :is-mirrored="false"
          >
            <!-- :is-draggable="draggable" -->
            <!-- dragAllowFrom=".dragFromHere" -->
            <!-- :dragAllowFrom="
                $vuetify.breakpoint.smAndDown
                  ? '.dragFromHere'
                  : '.ag-body-viewport'
              " -->
            <grid-item
                v-for="item in layout"
                :ref="`item-${item.i}`"
                @resized="gridResized(item, charts[item.i].type)"
                @moved="saveCardState(item.i, { eventType: 'moved' })"
                :key="item.i"
                :static="!item.draggable"
                :x="item.x"
                :y="item.y"
                :w="item.w"
                :h="item.h"
                :i="item.i"
                :minH="4"
                :minW="minimumGridWidth"
                :class="{ 'my-4': $vuetify.breakpoint.xsOnly }"
                class="draggable simple-slow-opacityAN"
                style="touch-action: none"
            >
              <chart-card
                  v-if="charts[item.i].type === VISUALIZATION_TYPES.CHART"
                  @edit="showChartConfigurationDialog"
                  @delete="showChartDeleteConfirmationDialog"
                  @draggable-switch="item.draggable = !item.draggable"
                  @change-history-option="
                  (option) => changeHistoryOption(option, item.i)
                "
                  @stepper-changed="(stepper) => stepperChanged(stepper, item.i)"
                  :ref="item.i"
                  :cardInfo="charts[item.i]"
                  :cardSymbol="charts[item.i].symbols"
                  :draggable="item.draggable"
                  :width="item.w"
                  :height="item.h"
                  :selectedHistoryOption="selectedHistoryOption"
                  :isNotDesktop="isNotDesktop"
                  :definitions="definitions"
                  :isAdmin="isAdmin"
                  :connectionLost="connectionLost"
                  :settingsLoaded="settingsLoaded"
              />
              <!-- <prices-card
                v-else-if="
                  charts[item.i].type == VISUALIZATION_TYPES.HISTORY_TABLE
                "
                :prices="prices"
                :cardInfo="charts[item.i]"
                :loadingPrices="loadingPrices"
                :symbols="
                  brokerSymbols[charts[item.i].tableProperties.brokerName]
                "
              /> -->
              <live-prices-card
                  v-else-if="
                  charts[item.i].type === VISUALIZATION_TYPES.LIVE_TABLE
                "
                  :ref="item.i"
                  @delete="showChartDeleteConfirmationDialog"
                  @update-table-symbols="
                  (ev) => updateLiveTableSymbols(ev, charts[item.i])
                "
                  @update-table-watchers="
                  (ev) => updateLiveTableWatchers(ev, charts[item.i])
                "
                  :definitions="definitions"
                  :cardInfo="charts[item.i]"
                  :tableHeight="item.h"
                  :watchers="watchers"
                  :headers="liveTableHeaders"
              />
            </grid-item>
          </grid-layout>

          <v-btn
              v-if="!loading"
              @click="wizardDialog = !wizardDialog"
              fab
              bottom
              right
              :style="{ bottom: '50px' }"
              :color="$vuetify.theme.dark ? 'secondary' : 'primary'"
              dark
              fixed
          >
            <v-icon>add</v-icon>
          </v-btn>

          <chart-configuration
              v-model="configurationDialog"
              @save="updateChartConfiguration"
              :configuration="chartConfiguration"
              :definitions="definitions"
              :watchers="watchers"
          />
          <confirm-dialog
              :dialog="confirmDialog"
              @confirmation-event="deleteChart"
              @mutate-confirm-dialog="(ev) => (confirmDialog = ev)"
              :text="itemDeletionText"
              :acceptButton="'Delete'"
          ></confirm-dialog>
          <!-- :text2="itemDeletionText2" -->
        </div>
        <chart-wizard
            v-model="wizardDialog"
            @create="createNewChart"
            :watchers="watchers"
            :definitions="definitions"
        />
      </div>
    </v-tabs-items>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import {GridItem, GridLayout} from "vue-grid-layout";
import ChartCard from "../components/PriceWatcher/ChartCard.vue";
import ChartWizard from "../components/PriceWatcher/ChartWizard.vue";
import LivePricesCard from "../components/PriceWatcher/LivePricesCard.vue";
import ChartConfiguration from "../components/PriceWatcher/ChartConfiguration.vue";
import {PriceWatcherMessageService} from "@/services/PricewatcherService";
import {
  ConfirmDialog,
  DefaultPage,
  LoadingPage,
} from "../components/Default-Page-Components";
import {VISUALIZATION_TYPES} from "@/utilities/enums";
import {
  ApplicationDefinitionService,
  ChartsService,
} from "@/services/ApiService";
import {events} from "@/plugins/events";

/* PLUGINS */
import {cloneDeep} from "lodash";

let liveDataInterval = null;

export default {
  name: "PriceWatcher",
  components: {
    GridItem,
    GridLayout,
    ChartCard,
    ChartWizard,
    LivePricesCard,
    ChartConfiguration,
    ConfirmDialog,
    LoadingPage,
    DefaultPage,
  },
  data() {
    return {
      minimumGridWidth: 22,
      liveTableHeaders: null,
      data: null,
      definitions: [],
      emptyPageText:
          "It seems that you don't have any charts yet. Click CREATE below to create a chart.",
      loadingCharts: true,
      loadingDefinitions: true,
      layout: [],
      VISUALIZATION_TYPES: VISUALIZATION_TYPES,
      cardToBeDeleted: null,
      confirmDialog: false,
      chartConfiguration: null,
      wizardDialog: false,
      configurationDialog: false,
      chartsOptions: {},
      resizable: true,
      charts: {},
      selectedWatchers: {},
      dataIsLive: false,
      loadingPrices: false,
      showingSymbolsOfBroker: "Client A",
      labels: null,
      pricesTableRenderKey: 0,
      selectedHistoryOption: "1D",
      selectedWatcher: "Client A",
      selectedSymbol: "EURUSD",
      prices: [],
      symbols: [
        {name: "EURUSD", timePeriod: "1 Dec - Now", selected: true},
        {name: "EURGBP", timePeriod: "1 Dec - Now", selected: false},
        {name: "EURJPY", timePeriod: "1 Dec - Now", selected: false},
        {name: "JPYUSD", timePeriod: "1 Dec - Now", selected: false},
        {name: "JPYGBP", timePeriod: "1 Dec - Now", selected: false},
        {name: "NZDUSD", timePeriod: "1 Dec - Now", selected: false},
        {name: "AUDUSD", timePeriod: "1 Dec - Now", selected: false},
        {name: "USDCHF", timePeriod: "1 Dec - Now", selected: false},
      ],
      priceWatchersHeaders: [
        {
          text: "Name",
          value: "name",
          align: "left",
          sortable: false,
          type: "String",
          currentSortAlg: null,
        },
        {
          text: "Actions",
          value: "actions",
          align: "left",
          type: "String",
          currentSortAlg: null,
        },
      ],
      loadingSpreads: true,
      loading: false,
      dark: false,
      currentType: null,
      dataTableItems: [],
      dataTableHeaders: [
        {
          text: "Ticks",
          align: "start",
          sortable: true,
          value: "tick",
        },
        {
          text: "Broker A",
          sortable: true,
          value: "brokerA",
        },
        {
          text: "Broker B",
          sortable: true,
          value: "brokerB",
        },
        {
          text: "Broker C",
          sortable: true,
          value: "brokerC",
        },
        {
          text: "Volume",
          sortable: false,
          value: "volume",
        },
      ],
    };
  },
  methods: {
    getFullIdentity(definition) {
      let stringID = definition.id.toString();
      let numberOfDigits = stringID.length;
      switch (numberOfDigits) {
        case 1:
          stringID = "00" + stringID;
          break;
        case 2:
          stringID = "0" + stringID;
          break;
        default:
          break;
      }

      return definition.application.code + stringID;
    },
    fitGridsToWindowSize(v) {
      // TODO
      // It seems that when a tablet is in horizontal mode
      // the minimumGridWidth is not calculated correctly (both when you switch to hroizontal mode & if you were in from the beggining)
      // for example on iPad Air the minimumGridWidth is 13 even though it should be 11 (width 1180)

      // See when the getMinimumGridWidth is called
      // see if there is any document property to use to see if its horizontally placed
      // and maybe check that when its horizontaly places the x becomes y & y becomes x

      let minWidth = this.getMinimumGridWidth(v);
      // Same functionality as setMinimumGridWidth()
      this.minimumGridWidth = minWidth;
      let ids = this.layout.reduce((final, next, index) => {
        let isLiveTable = false;
        if (this.charts.hasOwnProperty(next.i)) {
          isLiveTable =
              this.charts[next.i].type === VISUALIZATION_TYPES.LIVE_TABLE;
        }
        if (
            (isLiveTable && next.w < minWidth - 2) ||
            (!isLiveTable && next.w < minWidth)
        ) {
          final.push({
            id: next.i,
            type: isLiveTable
                ? VISUALIZATION_TYPES.LIVE_TABLE
                : VISUALIZATION_TYPES.CHART,
          });
        }
        return final;
      }, []);

      if (!ids.length) return;

      ids.forEach((item) => {
        let width =
            item.type === VISUALIZATION_TYPES.LIVE_TABLE
                ? minWidth - 2
                : minWidth;
        this.setGridWithMinimumWidth(item.id, width);
      });
    },
    setMinimumGridWidth() {
      // 600 is the default
      if (this.windowSizeX === 600)
        this.minimumGridWidth = $vuetify.breakpoint.xsOnly ? 22 : 6;
      else this.minimumGridWidth = this.getMinimumGridWidth(this.windowSizeX);
    },
    setGridWithMinimumWidth(itemId, minWidth) {
      let gridLayoutComponent = this.$refs["grid-layout"];
      let gridItemComponent = this.$refs[`item-${itemId}`][0];

      let itemLayoutParam = this.layout.find((obj) => obj.i === itemId);

      let layoutParams = {...itemLayoutParam};

      gridItemComponent.innerW = minWidth;
      layoutParams.w = minWidth;

      gridLayoutComponent.resizeEvent(
          "resizeend",
          itemId,
          layoutParams.x,
          layoutParams.y,
          layoutParams.h,
          layoutParams.w
      );
    },
    getMinimumGridWidth(windowSizeX) {
      if (windowSizeX > 1510) return 8;
      // else if(windowSizeX > 1430) return 9
      else if (windowSizeX > 1385) return 9;
      else if (windowSizeX > 1325) return 10;
      else if (windowSizeX > 1264) return 11;
      else if (windowSizeX > 1023) return 11;
      else if (windowSizeX > 860) return 12;
      else if (windowSizeX > 800) return 13;
      else if (windowSizeX > 745) return 14;
      else if (windowSizeX > 690) return 15;
      // else if(windowSizeX > 600) return 22
      else return 22;
    },
    removeReferance(v) {
      return JSON.parse(JSON.stringify(v));
    },
    updateLiveTableWatchers(watchers, chart) {
      // chart.symbols = symbols
      this.charts[chart.id].watchers = watchers;

      // this.charts[chart.id].height = (watchers.length/2) + 2;

      this.updateChartConfiguration(chart, {
        liveTable: true,
        modifiedProperty: "watchers",
      });
    },
    updateLiveTableSymbols(symbols, chart) {
      // chart.symbols = symbols
      if (!this.charts[chart.id]) {
        if (this.isAdmin)
          console.log(
              `Couldn't find the correct card to update. Card ID: ${chart.id}`
          );
        return;
      }

      this.charts[chart.id].symbols = symbols;

      this.updateChartConfiguration(chart, {
        liveTable: true,
        modifiedProperty: "symbols",
      });
    },
    updateChartComponent(chart, options = {}) {
      let newChart = this.createChartObject(chart);
      this.charts[chart.id] = newChart;

      if (
          options.eventType &&
          (options.eventType === "resized" ||
              options.eventType === "stepChange" ||
              options.eventType === "moved")
      ) {
        return;
      }

      events.$emit(`chart-${newChart.id}-update`, {
        type: "CARD_UPDATE",
        options: options,
      });
    },
    stepperChanged(stepper, chartId) {
      this.charts[chartId].stepper = stepper;
      this.saveCardState(chartId, {eventType: "stepChange"});
    },
    changeHistoryOption(option, chartId) {
      this.charts[chartId].historyOption = option;
      this.saveCardState(chartId);
    },
    draggableSwitch(chart) {
      chart.draggable = !chart.draggable;
    },
    isOutdatedConfiguration(configuration) {
      return (
          // !configuration.PriceGuard?.hasOwnProperty("PriceWatcherSymbols") || []
          !configuration.PriceGuard?.hasOwnProperty("PriceWatcherSymbols")
      );
    },
    fetchDefinitions() {
      this.loadingDefinitions = true;
      ApplicationDefinitionService.get()
          .then((response) => {
            console.log('Fetched definitions in PriceWatcher.vue', response.data.content);
            this.definitions = response.data.content.map((el) => {
              el.configuration = JSON.parse(el.configuration);
              // console.log("el.configuration", el.configuration);
              if (!el.configuration.hasOwnProperty("watched_symbols"))
                if (this.isOutdatedConfiguration(el.configuration)) {
                  console.log('is outdated configuration');
                  el.configuration.watched_symbols = [];
                } else {
                  console.log('has PriceWatcherSymbols', el.configuration.PriceGuard?.PriceWatcherSymbols);
                  el.configuration.watched_symbols =
                      el.configuration.PriceGuard?.PriceWatcherSymbols || [];
                }
              return el;
            });
            this.loadingDefinitions = false;
          })
          .catch((error) => {
            this.loadingDefinitions = false;
            this.$notifier.error(
                "Something went wrong when retrieving configurations."
            );
            console.error(error);
          });
    },
    openChartDialog() {
      this.wizardDialog = !this.wizardDialog;
    },
    refereshCharts() {
      this.fetchCharts(true);
    },
    // Create params to be sent in ChartsService.put()
    createChartUpdateParams(configuration) {
      // console.log('createChartUpdateParams configuration', configuration);
      let params = {
        name: configuration.name,
        properties: {
          type: configuration.type,
          watchers: configuration.watchers,
          symbols: configuration.symbols,
        },
        isPublic: configuration.isPublic,
      };
      let layout = this.layout.find((el) => el.i === configuration.id);
      if (!layout) {
        this.$notifier.error(
            "Oops! Something went wrong when updating the configuration!"
        );
        console.error(
            "Coulnd't find layout for this chart! ID:" + configuration.id
        );
        return;
      }
      params.properties.layout = layout;

      if (configuration.stepper)
        params.properties.stepper = configuration.stepper;
      if (configuration.historyOption)
        params.properties.historyOption = configuration.historyOption;

      return params;
    },
    createChartObject(chart) {
      // console.log('createChartObject chart arg', chart);
      let newChart = {
        id: chart.id,
        owner: chart.owner,
        name: chart.name,
        // symbols: chart.properties.symbols,
        watchers: chart.properties.watchers,
        type: chart.properties.type,
        isPublic: chart.isPublic,
      };

      /* Remove the following workaround with "symbols" for the live table and "symbol" for the chart*/
      newChart.symbols = chart.properties.symbols;

      //  When a new price comes
      // Update the chart not unly using the name but the alias as well
      // This support must be written in App.vue, PriceWatcher.vue & ChartCard.vue

      if (!Array.isArray(newChart.symbols)) {
        if (typeof newChart.symbols == "object")
          newChart.symbols = newChart.symbols.name;
      }

      // if (newChart.type == VISUALIZATION_TYPES.LIVE_TABLE)
      //   newChart.symbols = chart.properties.symbols;
      // else newChart.symbol = chart.properties.symbol;

      /**/
      if (chart.properties.historyOption)
        newChart.historyOption = chart.properties.historyOption;
      if (chart.properties.stepper) newChart.stepper = chart.properties.stepper;

      if (newChart.type === VISUALIZATION_TYPES.HISTORY_TABLE)
        newChart.tableProperties = {
          brokerName: chart.properties.watchers[0],
        };
      return newChart;
    },
    getWatchersNamesAndIds(watcherIds) {
      let names = [];
      watcherIds.forEach((watcherId) => {
        let watcher = this.watchers.find((el) => el.id === watcherId);
        if (watcher) names.push({name: watcher.name, id: watcher.id});
      });
      return names;
    },
    // The following function sets chartsOptions, charts & layout
    async fetchCharts(refreshCharts = false) {
      if (!refreshCharts) this.loadingCharts = true;
      try {
        let charts = await ChartsService.get();
        if (!charts.data.length) {
          if (refreshCharts) {
            this.charts = {};
            this.chartsOptions = {};
            this.layout = [];
          }
          this.loadingCharts = false;
          return;
        }
        // Set chart layout & configs
        charts.data.forEach((chart) => {
          if (!chart.properties.layout) {
            chart.properties.layout = {
              h: 6,
              w: 10,
              x: 0,
              y: 0,
              moved: false,
              draggable: true,
            };
          }
          chart.properties.layout.i = chart.id;

          let minW = this.getMinimumGridWidth(this.windowSizeX);
          if (chart.properties.layout.w < minW)
            chart.properties.layout.w = minW;

          let layoutAlreadyExists = this.layout.some((el) => el.i === chart.id);
          // console.log('layoutAlreadyExists', layoutAlreadyExists);
          // console.log('chart', chart);
          if (
              !layoutAlreadyExists &&
              (chart.isPublic === true ||
                  chart.owner === this.getUserInfo.name ||
                  this.isAdmin === true)
          )
            this.layout.push(chart.properties.layout);

          this.charts[chart.id] = this.createChartObject(chart);
        });

        // TODO
        // See the minimum width on laptops / tablets it seems to be pretty small
        // Add the nav-menu into consideration when calculating minW of a grid-item

        // Solution: fix the layout.w to at least a minimum width before it is pushed to this.layout

        // this.fitGridsToWindowSize();

        // Fetch & draw charts
        // this.fetchChartsData(charts.data);

        this.loadingCharts = false;
      } catch (error) {
        this.$notifier.error(
            "Oops! Something went wrong when retrieving data."
        );
        console.error(error);
        this.loadingCharts = false;
      }
    },
    async updateChartConfiguration(configuration, options = {}) {
      let params = this.createChartUpdateParams(configuration);

      try {
        let chartExists = this.charts.hasOwnProperty(configuration.id);

        let cardInfo;
        let response;
        if (chartExists) {
          cardInfo = this.charts[configuration.id];
        }
        cardInfo.isPublic = configuration.isPublic;

        if (cardInfo) {
          response = await ChartsService.put(cardInfo.id, params);

          // let cardInfo = this.charts.find((el) => el.id == configuration.id);
          cardInfo.symbols = configuration.symbols;

          cardInfo.watchers = configuration.watchers;
          cardInfo.name = configuration.name;

          if (options.liveTable) {
            // If its live table then update it
            this.$refs[cardInfo.id][0].rerenderTable(options.modifiedProperty);
          }
        } else {
          this.$notifier.error("Oops! Couldn't save the changes!");
          return;
        }
        // TODO
        // after this restart the component
        // thats the only way to change the name of the $on update event

        this.configurationDialog = false;

        this.updateChartComponent(response.data, options);
      } catch (error) {
        this.$notifier.error(
            "Oops! Something went wrong when updating the configuration!"
        );
        console.error(error);
      }
      // TODO
      // Here Update the Option objet of the chart with the above ID in "chartsOptions"
      // 1.) Some Watchers/Symbol might be added/removed/changed so you should update the option object accordingly
    },
    async deleteChart(ev) {
      if (!ev) {
        this.confirmDialog = false;
        return; // User clicked "Cancel"
      }
      let name = this.cardToBeDeleted.name;
      try {
        await ChartsService.delete(this.cardToBeDeleted.id);
        this.$notifier.info(`Chart ${name} deleted!`);

        this.confirmDialog = false;

        // this.charts = this.charts.filter(
        //   (el) => el.id != this.cardToBeDeleted.id
        // );
        delete this.charts[this.cardToBeDeleted.id];
        this.layout = this.layout.filter(
            (el) => el.i !== this.cardToBeDeleted.id
        );
        // remove the layour of the deleted chart this.layout
        delete this.chartsOptions[this.cardToBeDeleted.id];
        // this.fetchCharts();
      } catch (error) {
        console.error(error);
        this.$notifier.error(`Chart ${name} couldn't be deleted.`, {
          error: error,
        });
      }
    },
    showChartDeleteConfirmationDialog(cardInfo) {
      this.cardToBeDeleted = cardInfo;
      this.confirmDialog = true;
    },
    showChartConfigurationDialog(id) {
      this.configurationDialog = true;
      // let itemToEdit = this.chartsOptions[id]
      let chartExists = this.charts.hasOwnProperty(id);
      if (chartExists) {
        let itemToEdit = this.charts[id];
        // this.chartConfiguration = JSON.parse(JSON.stringify(itemToEdit));
        this.chartConfiguration = cloneDeep(itemToEdit);
      }
    },
    async createNewChart(chart) {
      // console.log('new chart data', chart);
      let name = chart.name;
      // TODO make sure that the object pushed to charts[]
      // contains name,symbol,watchers & chart type.
      // This is needed in showChartConfigurationDialog()
      // for "this.chartConfiguration = ..."
      // let id = Date.now();

      let highestChart = 0;
      Object.keys(this.charts).forEach((key) => {
        let totalHeight = this.charts[key].y + this.charts[key].h;
        if (totalHeight > highestChart) highestChart = totalHeight;
      });

      let cardHeight =
          chart.type === this.VISUALIZATION_TYPES.LIVE_TABLE
              ? chart.watchers.length / 2 + 4
              : 6;

      chart.layout = {
        x: 0,
        y: highestChart,
        w: 10,
        h: cardHeight,
        draggable: true,
      };

      delete chart.name;
      let params = {
        name: name,
        properties: chart,
        public: chart.isPublic,
        isPublic: chart.isPublic,
      };

      try {
        await ChartsService.post(params);
        this.$notifier.info(`Chart ${name} created!`);
        // if (newChart.type == this.VISUALIZATION_TYPES.HISTORY_TABLE)
        //   newChart.tableProperties = { brokerName: chart.watchers };
        // this.charts.push(newChart);
        // this.charts[] = newChart
        this.refereshCharts();
      } catch (error) {
        console.error(error);
        this.$notifier.error(`Chart ${name} couldn't be created.`, {
          error: error,
        });
      }
    },
    saveCardState(chartId, options = {}) {
      let chartExists = this.charts.hasOwnProperty(chartId);
      if (chartExists) {
        let itemToEdit = this.charts[chartId];
        let chartConfiguration = JSON.parse(JSON.stringify(itemToEdit));
        this.updateChartConfiguration(chartConfiguration, options);
      }
    },
    gridResized(layout, type) {
      if (type === this.VISUALIZATION_TYPES.CHART)
        this.$refs[layout.i][0].sizeChartToFit(layout.i, layout.w, layout.h);

      this.saveCardState(layout.i, {eventType: "resized"});
    },
    getNewHistoryData(option, initialDate = false) {
      let dataPointsTimeStrings;
      let timeInMilliseconds = {
        minute: 60000,
        hour: 3600000,
        day: 86400000,
      };
      let newDate,
          newData = [];
      let dataPoints = 10;
      let unformatednewDate = new Date();
      // if(initialDate) newDate = date
      switch (option) {
        case "1H":
          // Every 1 minute
          dataPoints = 60;

          newDate = unformatednewDate.getTime() - timeInMilliseconds.hour;
          // Calculate the xAxis numbers for all dataPoints of the curve
          dataPointsTimeStrings = Array.from(new Array(60), (item, i) => {
            return newDate + i * timeInMilliseconds.minute;
          });
          break;
        case "1D":
          // Every 1 hour
          dataPoints = 24;
          // Now minus a day
          // if(!initialDate)
          newDate = unformatednewDate.getTime() - timeInMilliseconds.day;
          // Calculate the xAxis numbers for all dataPoints of the curve
          dataPointsTimeStrings = Array.from(new Array(24), (item, i) => {
            return newDate + i * timeInMilliseconds.hour;
          });
          break;
        case "7D":
          // Total Hours : 169
          // Every 4 hours
          dataPoints = 42;
          // Now minus a week
          // if(!initialDate)
          newDate = unformatednewDate.getTime() - timeInMilliseconds.day * 7;
          // Calculate the xAxis numbers for all dataPoints of the curve
          dataPointsTimeStrings = Array.from(new Array(42), (item, i) => {
            return newDate + i * timeInMilliseconds.hour * 4;
          });
          break;
        case "1M":
          // Every 1 day
          dataPoints = 30;
          break;
        case "All":
          // Every 1 day
          dataPoints = 30;
          break;
      }

      let date = newDate;
      for (let i = 0; i < dataPoints; i++) {
        // var dayStr = date + (this.option.series[0].data.length + 1) * 60000;
        const dayStr = dataPointsTimeStrings[i];
        let value = (Math.random() * (1.99 - 1.7 + 1) + 1.7).toFixed(2);
        newData.push([dayStr, value]);
      }
      return newData;
    },
    stopLiveData() {
      clearInterval(liveDataInterval);
      this.dataIsLive = false;
    },
    startLiveData() {
      this.dataIsLive = true;
    },
  },
  computed: {
    ...mapGetters(["getUserInfo", "isAdmin"]),
    ...mapGetters("instances", [
      "getApplicationInstances",
      "getApplicationInstancesUnfiltered",
    ]),
    // dragAllowFrom() {
    //   return this.$vuetify.breakpoint.smAndDown || this.isNotDesktop
    //     ? ".dragFromHere"
    //     : ".ag-body-viewport";
    // },
    itemDeletionText() {
      if (!this.cardToBeDeleted) return "";
      let type =
          this.cardToBeDeleted.type === this.VISUALIZATION_TYPES.CHART
              ? "chart"
              : "table";
      return `Delete the ${this.cardToBeDeleted.name} ${type}?`;
    },
    watchers() {
      // return this.getApplicationInstances.reduce((final, next) => {
      return this.getApplicationInstancesUnfiltered.reduce((final, next) => {
        // if (next.applicationCode == "PW")
        final.push({
          id: next.identity,
          name: next.name,
          appStatus: next.appStatus,
        });
        // final.push({
        //   id: next.id,
        //   name: next.name,
        //   appStatus: next.appStatus,
        //   selected: this.selectedWatchers[next.name] || false,
        // });
        return final;
      }, []);
    },
  },
  props: {
    isNotDesktop: {
      type: Boolean,
      default: false,
    },
    windowSizeX: {
      type: Number,
      default: 600,
    },
    connectionLost: {
      type: Boolean,
      default: false,
    },
    settingsLoaded: {
      type: Boolean,
      default: false,
    },
  },

  created() {
    this.fetchDefinitions();
    this.fetchCharts();
  },
  mounted() {
    this.setMinimumGridWidth();

    this.subscription = PriceWatcherMessageService.getMessage().subscribe(
        (message) => {
          // For each symbol of message.data check if at least one chart with that symbol exists
          // and if message.identity is in their watchers
          // If yes then $emit event for that symbol into the charts
          try {
            let identity = message.identity;

            message.data.forEach((priceUpdate) => {
              let chartkeys = Object.keys(this.charts);

              let chartsToUpdate = [];

              chartkeys.forEach((key) => {
                // Check if there is at least one chart with same symbol and historyOption: live

                if (this.charts[key].type !== VISUALIZATION_TYPES.CHART) {
                  return false;
                }

                let definition = this.definitions.find(
                    (def) => this.getFullIdentity(def) === identity
                );

                if (!definition) {
                  return;
                }
                let watchedSymbols = definition.configuration.watched_symbols;

                // Helper description:
                // *updateSymbol* --> is the symbol from the price update that was received through SSE

                // Description of chartOfThisSymbol:
                // chartOfThisSymbol means that this chart's symbol is the same as *updateSymbol*

                // Description of chartOfThisSymbolAlias:
                // chartOfThisSymbolAlias means that this chart symbol's alias is the same as *updateSymbol*

                let chartOfThisSymbol =
                    this.charts[key].symbols === priceUpdate.symbol;

                // Check if the price update symbol is an alias of another symbol that is this card
                let chartSymbolSettings = watchedSymbols.find((el) => {
                  if (typeof el == "string") {
                    return el === this.charts[key].symbols;
                  } else
                    return (
                        el.name === this.charts[key].symbols ||
                        el.alias === this.charts[key].symbols
                    );
                });

                let chartOfThisSymbolAlias;
                // Handle outdated code of symbol settings
                if (
                    chartSymbolSettings === undefined ||
                    typeof chartSymbolSettings == "string"
                )
                  chartOfThisSymbolAlias = false;
                else {
                  chartOfThisSymbolAlias =
                      chartSymbolSettings.alias === priceUpdate.symbol;
                }

                // Description of isLive: The chart is in "live" mode
                let isLive = this.charts[key].historyOption === "LIVE";
                // Description of watcherExists: One of the charts' watchers is the watcher of the new message(update)
                let watcherExists = this.charts[key].watchers.some(
                    (watcher) => watcher === message.identity
                );

                if (
                    isLive &&
                    (chartOfThisSymbol || chartOfThisSymbolAlias) &&
                    watcherExists
                ) {
                  chartsToUpdate.push(key);
                }
              });

              chartsToUpdate.forEach((chart) => {
                events.$emit(`chart-${chart}-update`, {
                  type: "PRICE_UPDATE",
                  update: priceUpdate,
                  identity: message.identity,
                });
              });
            });
          } catch (error) {
            console.error("Error when updating live chart data!");
            console.error(error);
          }
        }
    );
  },
  watch: {
    windowSizeX(v) {
      this.fitGridsToWindowSize(v);
    },
  },
};
</script>
<style>
.PW-card-layout .vue-grid-item > .vue-resizable-handle {
  bottom: -12px !important;
  /* bottom: 0px !important; */
  right: -12px !important;
}

.navDraw-helper {
  width: 20px;
  height: 800px;
  position: fixed;
  background: transparent;
  z-index: 999;
}

/* CSS of LivePricedCard component - start */
.live_table_cell {
  transition: background-color 500ms linear;
  -webkit-transition: background-color 500ms linear;
}

.live_table_cell.primary--text {
  transition: background-color 500ms linear;
  -webkit-transition: background-color 500ms linear;
}

.live_table_cell.primary--text {
  background: #358d7071;
}

.live_table_cell.secondary--text {
  background: #588b7a71;
}

.live_table_cell.red--text {
  transition: background-color 500ms linear;
  -webkit-transition: background-color 500ms linear;
  background: rgb(183, 28, 28, 0.3);
}

/* CSS of LivePricedCard component - end */

/* CSS of ChartCard component - start */
.live_data_icon {
  position: absolute;
  width: 25px;
  left: 1px;
  top: 4px;
}

.live_data_icon .circle--outer {
  border: 1px solid white;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin: 0 auto 5px;
  position: relative;
  opacity: 0.8;
  -webkit-animation: circle 3s ease-in-out 0.1s infinite;
  animation: circle 3s ease-in-out 0.1s infinite;
}

.live_data_icon .circle--inner:after {
  content: "";
  display: block;
  border: 2px solid rgba(255, 255, 255, 0.603);
  border-radius: 50%;
  width: 14px;
  height: 14px;
  top: 2px;
  left: 8px;
  position: absolute;
  opacity: 0.8;
  -webkit-animation: circle 3s ease-in-out infinite;
  animation: circle 3s ease-in-out infinite;
}

.live_data_icon p {
  color: #000;
  text-align: center;
}

.active-card i {
  color: white !important;
}

.active-card .history-option {
  color: white !important;
}

@keyframes circle {
  0% {
    opacity: 1;
    transform: scale(0.5);
  }
  60% {
    transform: scale(1.5);
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}

@-webkit-keyframes circle {
  0% {
    opacity: 1;
    -webkit-transform: scale(0.5);
  }
  60% {
    -webkit-transform: scale(1.5);
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}

/* CSS of ChartCard component - end */
.chart-tooltip-value {
  display: inline-block;
  margin-right: 4px;
  border-radius: 10px;
  width: 10px;
  height: 10px;
}

.watcher-history-option {
  border-radius: 8px !important;
}

.watcher-history-option div {
  width: 30px;
}
</style>
